<template>
    <paper class='bill'>
        <m-pane
            ref="tablePage"
            :config="config"
            :searchTotalTitle="config.searchTotalTitle"
            :totalData="totalData"
            :pageTotal="pageTotal"
            :loading="loading"
            :currentPage="currentPage"
            searchId="billQuery"
            pageID="bill"
            @row-db-click="rowDBclick"
            @selectChange="selectChange"
            @searchChange="searchChange"
            @pageChange="pageChange"
            @sizeChange="sizeChange">
            <div slot="table-module-btn"></div>
        </m-pane>
    </paper>
</template>

<script>
import mPane from '@/components/supplierPanel';
import paper from '@/components/core/paper/Paper';
import config from './config.js';
import formatTime from '@/utils/common.js';
import { del } from '../../../components/judge/bmsModular';
import { getSettleLists } from '../../../api/settleApi.js';
import common from '../../../common/common';
const { initSessionData } = common;
export default {
    name: 'settleIndex',
    components: { mPane, paper },
    data() {
        return {
            invoiceStatusObj: {},
            paymentStatusObj: {},
            applyStatusObj: {},
            selected: [],
            searchDataLists: {},
            currentPage: 1,
            selectData: [],
            searchObj: {
                pageNo: 1,
                pageSize: 10
            },
            pageTotal: 0,
            totalData: [],
            loading: false,
            config
        };
    },
    methods: {
        // 首页跳转过来 参数处理
        handleTodo() {
            this.$set(this.searchDataLists, 'statusArray', this.$route.query.status || '');
            this.$refs.tablePage.$refs.searchList.setQueryParams({ ...this.searchDataLists, statusArray: this.$route.query.status.split(',') || [] });
            this.$router.replace({ query: {} });
            this.load();
        },
        load() {
            this.$refs.tablePage.$refs.searchList.changeLoading(true);
            this.loading = true;
            const params = { pageNo: this.searchObj.pageNo, pageSize: this.searchObj.pageSize, ...this.searchDataLists };
            this.currentPage = this.searchObj.pageNo;
            getSettleLists(params).then(res => {
                if (res && res.code === '0') {
                    this.totalData = res.data.list.map(item => {
                        const { SYS_BMS_AP_APPLY_STATUS_SUPP, SYS_BMS_APPLY_INVOICE_STATUS, SYS_BMS_AP_PAYMENT_STAT_SUPP } = window.sessionStorage;
                        item.invoiceStatusText = JSON.parse(SYS_BMS_APPLY_INVOICE_STATUS)[item.invoiceStatus];
                        item.payStatusText = JSON.parse(SYS_BMS_AP_PAYMENT_STAT_SUPP)[item.payStatus];
                        item.statusText = JSON.parse(SYS_BMS_AP_APPLY_STATUS_SUPP)[item.status];
                        return item;
                    });
                    this.pageTotal = res.data.totalCount;
                }
                this.loading = false;
                this.$refs.tablePage.$refs.searchList.changeLoading(false);
            }).catch(() => {
                this.$refs.tablePage.$refs.searchList.changeLoading(false);
                this.loading = false;
            });
        },
        pageChange(data) {
            this.searchObj.pageNo = data;
            this.load();
        },
        sizeChange(data) {
            this.currentPage = 1;
            this.searchObj.pageSize = data;
            this.searchObj.pageNo = 1;
            this.load();
        },
        searchChange(data) {
            this.searchObj.pageNo = 1;
            data.statusArray && (data.statusArray = data.statusArray.join());
            data = this.formattingData(data);
            delete data.accountName;
            this.searchDataLists = data;
            this.load();
        },
        /**
         * 确认账单开始时间:startSubdateTime 确认账单结束时间:endSubdateTime 开票开始时间:startInvoiceTime 开票结束时间:endInvoiceTime
         * 收票开始时间:startExpireDateTime 收票结束时间:endExpireDateTime 付款开始时间:startPaymentTime  付款结束时间:endPaymentTime
         */
        formattingData(data) {
            const tempData = {
                startSubdateTime: data.subdate2 ? formatTime.formatDate(data.subdate2[0]) + ' 00:00:00' : '',
                endSubdateTime: data.subdate2 ? formatTime.formatDate(data.subdate2[1]) + ' 23:59:59' : '',
                startInvoiceTime: data.openInvoiceDate ? formatTime.formatDate(data.openInvoiceDate[0]) + ' 00:00:00' : '',
                endInvoiceTime: data.openInvoiceDate ? formatTime.formatDate(data.openInvoiceDate[1]) + ' 23:59:59' : '',
                startExpireDateTime: data.expireDate ? formatTime.formatDate(data.expireDate[0]) + ' 00:00:00' : '',
                endExpireDateTime: data.expireDate ? formatTime.formatDate(data.expireDate[1]) + ' 23:59:59' : '',
                startPaymentTime: data.checkDate ? formatTime.formatDate(data.checkDate[0]) + ' 00:00:00' : '',
                endPaymentTime: data.checkDate ? formatTime.formatDate(data.checkDate[1]) + ' 23:59:59' : '',
                createTimeFrom: data.createTime ? formatTime.formatDate(data.createTime[0]) + ' 00:00:00' : '',
                createTimeTo: data.createTime ? formatTime.formatDate(data.createTime[1]) + ' 23:59:59' : '',
                ...data
            };
            this.tempData = del(tempData, ['subdate2', 'expireDate', 'openInvoiceDate', 'checkDate', 'createTime']);
            return tempData;
        },
        rowDBclick(row) {
            this.$router.push({ query: { apApplyNo: row.apApplyNo, jobid: row.jobId }, path: `/bms/SettleDetails` });
        },
        selectChange(data) {
            data.forEach(item => {
                this.apBillNo = item.apBillNo;
            });
            this.selected = [].concat(data);
        },
        getTableData() {

        }
    },
    mounted() {
        initSessionData(['SYS_BMS_AP_PAYMENT_STAT_SUPP', 'SYS_BMS_APPLY_INVOICE_STATUS', 'SYS_SC_INVOICE_TYPE', 'SYS_BMS_AP_APPLY_STATUS_SUPP']);
        if (this.$route.query.from === 'todoList') {
            this.handleTodo();
        } else {
            this.$refs.tablePage.$refs.searchList.onSearchChange();
        }
    },
    activated() {
        // 首页跳转过来 参数处理
        if (this.$route.query.from === 'todoList') {
            this.handleTodo();
        }
    },
    created() {
        this.$set(this.config.searchList.searchTxt[4], 'data', this.$route.query.settleData);
        this.$set(this.config.searchList.searchTxt[3], 'data', '');
        this.$set(this.config.searchList.searchTxt[5], 'data', '');
        this.$set(this.config.searchList.searchTxt[2], 'timeNum', '');
    }

};
</script>

<style lang="less">
</style>
